<template>
  <div>
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form :inline="true" size="mini" label-width="100px" :model="formData" ref="searchForm">
            <el-form-item label="SPU编码" prop="spuCode">
              <el-input v-model.trim="formData.spuCode" placeholder="请输入SPU编码" @keyup.enter.native="onSearch"></el-input>
            </el-form-item>
            <el-form-item label="SPU名称" prop="spuName">
              <el-input v-model.trim="formData.spuName" placeholder="请输入SPU名称" @keyup.enter.native="onSearch"></el-input>
            </el-form-item>
            <el-form-item label="SKU编码" prop="skuCode">
              <el-input v-model.trim="formData.skuCode" placeholder="请输入SKU编码" @keyup.enter.native="onSearch"></el-input>
            </el-form-item>
            <el-form-item label="SKU名称" prop="skuName">
              <el-input v-model.trim="formData.skuName" placeholder="请输入SKU名称" @keyup.enter.native="onSearch"></el-input>
            </el-form-item>
            <el-form-item label="计划人员" prop="devicePerson">
              <el-select v-model="formData.devicePerson" filterable placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option :label="item" :value="item" v-for="(item, index) in devicePersonList" :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="SKU进度" prop="taskIds">
              <el-select v-model="formData.taskIds" placeholder="请选择" multiple collapse-tags>
                <el-option :label="item.taskName" :value="item.taskId" v-for="(item, index) in taskList" :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="SPU备注" prop="productRemark">
              <el-input v-model.trim="formData.productRemark" placeholder="请输入SPU备注" @keyup.enter.native="onSearch"></el-input>
            </el-form-item>
            <el-form-item label="待办状态" prop="status">
              <el-select v-model="formData.status" placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option label="延期" value="0"></el-option>
                <el-option label="回退" value="1"></el-option>
                <el-option label="正常" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="预计上线时间">
              <form-date-range :form="formData" startKey="startTime" endKey="endTime" :usingTime="false" valueFormat="yyyy-MM-dd"></form-date-range>
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-tag type="primary" closable size="small" @close="onReset" v-show="nodeName">{{ nodeName }}</el-tag>
            <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
            <el-button class="orange-btn" size="mini" @click="onReset">重置</el-button>
          </template>
        </search-box>
      </template>

      <table-panel ref="tablePanel">
        <template v-slot:header-right>
          <el-button type="primary" size="mini" @click="spuAdd" v-permission="`ec-pc-new$productLifeCycle$aboutNew$newproduct-process$spuADD`">新增SPU</el-button>
          <el-button type="primary" size="mini" @click="showExport">导出报表</el-button>
          <el-button slot="reference" type="primary" size="mini" @click="tableVisible = true">表格设置</el-button>
        </template>
        <el-table
          border
          stripe
          :header-cell-style="{ backgroundColor: '#F4F8FB' }"
          :data="tableData"
          :height="maxTableHeight"
          :span-method="objectSpanMethod"
          :cell-class-name="
            ({ row, column, rowIndex, columnIndex }) => {
              if (columnIndex === 2) {
                return 'spu-name-col';
              }
            }
          "
          v-if="tableReload"
          v-loading="loading"
        >
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            :min-width="item.width"
            :sortable="item.sortable ? 'custom' : false"
            :fixed="item.fixed"
            show-overflow-tooltip
            v-for="item in columnData"
            :key="item.prop"
          >
            <template slot-scope="scope">
              <div v-if="item.label === '图片'">
                <template>
                  <template v-if="scope.row.picList && scope.row.picList.length">
                    <el-link :underline="false" type="primary" @click="showDialog(scope.row, 0)">查看</el-link>
                  </template>
                </template>
              </div>
              <div v-else-if="item.label === 'SPU编码'">
                <template>
                  <span>{{ scope.row.spuCode }}</span>
                  <div class="over-time-tag">
                    <el-tag type="warning" size="mini" v-if="scope.row.dataType && scope.row.dataType.paperwork == 1">文</el-tag>
                    <el-tag type="warning" size="mini" v-if="scope.row.dataType && scope.row.dataType.remark == 1">备</el-tag>
                  </div>
                </template>
              </div>
              <div v-else-if="item.label === 'SKU编码'">
                <template>
                  <span>{{ scope.row.skuCode }}</span>
                  <el-tag class="over-time-tag" type="danger" v-if="scope.row.isOverTime == 1" size="mini">超时</el-tag>
                  <el-tag class="over-time-tag" type="danger" v-if="scope.row.isSkipDemand == 1" size="mini">订单制</el-tag>
                  <el-tag class="over-time-tag" type="danger" v-if="scope.row.isEnd == 1" size="mini">已终止</el-tag>
                </template>
              </div>
              <div v-else-if="item.label === 'SKU进度'">
                <template>
                  <span>{{ scope.row.taskName }}</span>
                  <div class="over-time-tag">
                    <el-tag type="warning" size="mini" v-if="scope.row.paperworkNum > 0">文</el-tag>
                  </div>
                </template>
              </div>
              <div v-else>
                <template>
                  {{ scope.row[item.prop] }}
                </template>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="操作" fixed="right" width="120px">
            <template slot-scope="scope" v-if="columnData.length">
              <el-link
                :underline="false"
                type="primary"
                v-permission="`ec-pc-new$productLifeCycle$aboutNew$newproduct-process$editspu`"
                @click="editSpu(scope.row.spuCode)"
                >修改</el-link
              >
              <el-link :underline="false" type="primary" @click="showDetail(scope.row.spuCode, scope.row.dataId)">查看详情</el-link>
            </template>
          </el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="paginationOpt.pageNum"
              :page-sizes="paginationOpt.pageSizes"
              :page-size="paginationOpt.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              background
              :total="paginationOpt.total"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
    <!-- 新增、修改 -->
    <!-- <review-product-add
      v-if="addDialogVisible"
      :show="addDialogVisible"
      :data="editData"
      :actionType="actionType"
      @close="onClose"
    /> -->
    <!-- 视频、图片查看 -->
    <pic-video v-model="picVideoVisible" :data="rowData" :detailType="viewType" v-if="picVideoVisible"></pic-video>

    <export-excel v-model="exportExcelVisible" :formData="formData" v-if="exportExcelVisible"></export-excel>
    <batch-upload :visible.sync="batchUploadVisible" v-if="batchUploadVisible"></batch-upload>
    <edit-spu v-model="editSpuVisible" :spuCode="activeSpuCode" v-if="editSpuVisible" @success="handleEditSuccess"></edit-spu>
    <custom-table v-model="tableVisible" :tableDataSet="tableDataSet" v-if="tableVisible" @closeAddForm="closeAddForm" @confirm="confirm"></custom-table>
  </div>
</template>

<script>
import 'element-ui/lib/theme-chalk/display.css';
import picVideoMxin from './pic&video.mixin';
import exportExcel from './export-excel';
import batchUpload from './batch-upload/batch-upload';
import editSpu from './editSpu';
import customPropsMixin from './customProps.mixin';
import pagePathMixin from '@/utils/page-path-mixin';
import tableMixin from '@/utils/tableMixin';

export default {
  name: 'newproductProcess',
  mixins: [picVideoMxin, customPropsMixin, pagePathMixin, tableMixin],
  components: {
    exportExcel,
    batchUpload,
    editSpu,
  },
  data() {
    return {
      loading: false,
      formData: {
        spuCode: '',
        spuName: '',
        skuCode: '',
        skuName: '',
        taskIds: [],
        devicePerson: '',
        productRemark: '',
        pendingStatus: '',
        status: '',
        startTime: '',
        endTime: '',
      },
      taskList: [],
      devicePersonList: [],
      nodeName: '',
      tableData: [],
      paginationOpt: {
        pageSizes: [30, 60, 90],
        pageSize: 30,
        pageNum: 1,
        total: 0,
      },
      exportExcelVisible: false,
      batchUploadVisible: false,
      editSpuVisible: false,
      activeSpuCode: '',
      tableReload: true,
      pendingDataNum: 0,
    };
  },
  mounted() {
    if (this.$route.query) {
      this.$set(this.formData, 'spuCategory', this.$route.query.spuCategory);
      this.$set(this.formData, 'spuOnShelfFlag', this.$route.query.spuOnShelfFlag);
      this.$set(this.formData, 'startTime', this.$route.query.startTime);
      this.$set(this.formData, 'endTime', this.$route.query.endTime);
      this.$set(this.formData, 'spuIdList', this.$route.query.spuIdList ? this.$route.query.spuIdList.split(',') : []);
      this.$set(this.formData, 'devicePerson', this.$route.query.devicePerson || '');
      this.$set(this.formData, 'status', this.$route.query.status || '');
      this.$set(this.formData, 'taskIds', this.$route.query.taskIds ? (Array.isArray(this.$route.query.taskIds) ? this.$route.query.taskIds : [this.$route.query.taskIds]) : []);
    }
    this.getTaskList();
    this.getDevicePerson();
    this.addEventlistener_lineChartClicked();
    this.init();
  },
  watch: {
    $route: {
      handler(val, olv) {
        if ((olv.path == '/newProduct/newproduct-overview' || olv.path == '/productLifeCycle/administration') && val.query) {
          this.$set(this.formData, 'spuCategory', val.query.spuCategory);
          this.$set(this.formData, 'spuOnShelfFlag', val.query.spuOnShelfFlag);
          this.$set(this.formData, 'startTime', val.query.startTime);
          this.$set(this.formData, 'endTime', val.query.endTime);
          this.$set(this.formData, 'taskIds', val.query.taskIds ? (Array.isArray(val.query.taskIds) ? val.query.taskIds : [val.query.taskIds]) : []);
          this.paginationOpt.pageNum = 1;
          this.columns();
          this.init();
        } else if (olv.path == '/newProduct/newproduct-add' && val.params.type) {
          this.paginationOpt.pageNum = 1;
          this.init();
        } else if (olv.path == '/dataBoard/agencyWorkbench' && val.query.devicePerson) {
          this.restFormData();
          this.$set(this.formData, 'devicePerson', val.query.devicePerson || '');
          this.$set(this.formData, 'taskIds', val.query.taskIds ? (Array.isArray(val.query.taskIds) ? val.query.taskIds : [val.query.taskIds]) : []);
          this.$set(this.formData, 'startTime', val.query.startTime || '');
          this.$set(this.formData, 'endTime', val.query.endTime || '');
          this.$set(this.formData, 'status', val.query.status || '');
          this.paginationOpt.pageNum = 1;
          this.init();
        }
      },
    },
  },
  methods: {
    restFormData() {
      this.formData = {
        spuCode: '',
        spuName: '',
        skuCode: '',
        skuName: '',
        taskIds: [],
        devicePerson: '',
        productRemark: '',
        pendingStatus: '',
        status: '',
        startTime: '',
        endTime: '',
      };
    },
    addEventlistener_lineChartClicked() {
      this.$bus.$off('lineChartClicked').$on('lineChartClicked', ({ name, type }) => {
        this.nodeName = name;
        const found = this.taskList.find((v) => v.taskName == name);
        const id = found ? found.taskId : '';

        this.$set(this.formData, 'taskId', '');
        this.$set(this.formData, 'spuTaskId', '');
        if (type == 'sku') {
          this.$set(this.formData, 'taskId', id);
        } else {
          this.$set(this.formData, 'spuTaskId', id);
        }
        this.onSearch();
      });
    },
    getTaskList() {
      this.$q.newProduct.getTask().then((res) => {
        if (res.code == 200) {
          this.taskList = res.data;
        } else {
          this.taskList = [];
        }
      });
    },
    getDevicePerson() {
      this.$q.newProduct.getDevicePerson().then((res) => {
        this.devicePersonList = res.data;
      });
    },
    onSearch() {
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    onReset() {
      this.nodeName = '';
      this.$refs.searchForm.resetFields();
      this.formData = {
        spuCode: '',
        spuName: '',
        skuCode: '',
        skuName: '',
        taskIds: [],
        devicePerson: '',
        productRemark: '',
        pendingStatus: false,
        status: '',
        startTime: '',
        endTime: '',
        restType: true,
      };
      this.$set(this.formData, 'spuIdList', []);
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    init() {
      this.loading = true;
      let formData = {
        pageSize: this.paginationOpt.pageSize,
        pageNum: this.paginationOpt.pageNum,
        filterData: {
          ...this.formData,
          pendingStatus: this.formData.pendingStatus ? 'Y' : '',
        },
      };
      this.$q.newProduct
        .listPageNew({ data: formData })
        .then((res) => {
          let tableData = [];
          res.data.records.forEach((item) => {
            let spuItem = JSON.parse(JSON.stringify(item));
            delete spuItem['skuList'];
            if (item.skuList && item.skuList.length) {
              item.skuList.forEach((e, i) => {
                tableData.push({
                  ...spuItem,
                  ...e,
                  dataId: spuItem.dataId,
                  skuLength: i === 0 ? item.skuList.length : null,
                });
              });
            } else {
              tableData.push({
                ...spuItem,
                skuLength: 1,
              });
            }
          });
          this.tableData = tableData;
          this.paginationOpt['total'] = res.data.total;
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.paginationOpt.pageSize = val;
      this.paginationOpt.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.paginationOpt.pageNum = val;
      this.init();
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      const spanArr = this.columnData.filter((v) => v.span);
      if (spanArr.find((v) => v.prop === column.property) || column.label === '图片' || column.label === '操作') {
        if (row.skuLength) {
          return {
            rowspan: row.skuLength,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    spuAdd() {
      this.openSubPage({ path: '/newProduct/newproduct-add' });
    },
    showExport() {
      this.exportExcelVisible = true;
    },
    showDetail(spuCode, spuId) {
      if (!spuCode) return;
      this.openSubPage({
        name: 'newproductDetail',
        query: {
          spuCode,
          spuId,
        },
      });
    },
    batchUpload() {
      this.batchUploadVisible = true;
    },
    editSpu(code) {
      this.activeSpuCode = code;
      this.editSpuVisible = true;
    },
    handleEditSuccess() {
      this.init();
    },
  },
};
</script>
<style lang="stylus" scoped>
.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
    width 240px !important
>>> .date-range .single-date
  width 110px !important

.over-time-tag {
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translate(0, -50%);
}

>>> .cell.el-tooltip {
  width: 100% !important;
}

>>> .spu-name-col .cell {
  white-space: normal !important;
}
</style>
